import styled from 'react-emotion';
import { Button } from 'material-ui';

import theme from '../lib/theme';

export const GradientButton = styled(Button)`
  background: linear-gradient(to bottom right, ${theme.palette.secondary.A200} 30%, ${theme.palette.primary.A400} 90%);
  color: white;
`;


// WEBPACK FOOTER //
// ./src/components/GradientButton.jsx